export const TEST_ID = 'orgFieldPickerColumn';

export const SKELETON_ROW_COUNT = 6;
